import OrderApi from "../../services/order.service";
import { CartData, LocationId } from "../../services/storage.service";
import isEmpty from "../../utils/isEmpty";
import router from "../../router";

const state = {
  cart: isEmpty(CartData.getCartItems()) ? [] : CartData.getCartItems(),
  totalPrice: isEmpty(CartData.getCartTotal()) ? 0 : CartData.getCartTotal(),
  deliveryCharge: 0,
  locationMarker: null,
  popOrderConfirm: false,
  ordering: false,
  loc_id: LocationId.getLocationId(),
  promoDiscount: 0,
  promoDiscountTotal: 0,
  cookedFoodDiscount: 0,
  martDiscount: 0,
  bakeryDiscount: 0,
  liquorDiscount: 0,
  promoCode: "",
  orderError: "",
  minOrder: 0,
  sM: "",
  orderFor: 0,
  paymentMethod: "",
  deliveryLocation: "",
  step: 0,
  payMode: "",
  vat: 0,
  intl_transfer_charge: 0,
  promoInfo: "",
  promoStatus: false,
};

const getters = {
  locationId: (state) => state.loc_id,
  cartItems: (state) => state.cart,
  totalPrice: (state) => state.totalPrice,
  cartTotal: (state) => {
    return state.cart.reduce((a, b) => a + b.after_price * b.quantity, 0);
  },
  userDetail: (state) => state.userDetail,
  locationMarker: (state) => state.locationMarker,
  popOrderConfirm: (state) => state.popOrderConfirm,
  ordering: (state) => state.ordering,
  getOrderError: (state) => state.orderError,
  getMinOrder: (state) => state.minOrder,
  getPromoDiscount: (state) => state.promoDiscount,
  getPromoDiscountTotal: (state) => state.promoDiscountTotal,
  getCookedFoodDiscount: (state) => state.cookedFoodDiscount,
  getMartDiscount: (state) => state.martDiscount,
  getBakeryDiscount: (state) => state.bakeryDiscount,
  getLiquorDiscount: (state) => state.liquorDiscount,
  getPromoCode: (state) => state.promoCode,
  deliveryCharge: (state) => state.deliveryCharge,
  sM: (state) => state.sM,
  orderFor: (state) => state.orderFor,
  paymentMethod: (state) => state.paymentMethod,
  deliveryLocation: (state) => state.deliveryLocation,
  formStep: (state) => state.step,
  payMode: (state) => state.payMode,
  getVAT: (state) => state.vat,
  getIntlTransferCharge: (state) => state.intl_transfer_charge,
  getPromoInfo: (state) => state.promoInfo,
  getPromoStatus: (state) => state.promoStatus,
};

const actions = {
  applyDeliveryCharge({ commit }, charge) {
    commit("addDeliveryCharge", charge);
  },

  applyITC({ commit }, charge) {
    commit("addTransferCharge", charge);
  },

  applyVAT({ commit }, charge) {
    commit("addVATCharge", charge);
  },

  addToCart({ commit }, item) {
    commit("addItem", item);
    commit("addTotal", item.after_price);
  },
  deleteItem({ commit }, id) {
    commit("itemPriceDelete", id);
    commit("itemDelete", id);
  },
  addQuantity({ commit }, id) {
    commit("quantityAdd", id);
    commit("upTotal", id);
  },
  minusQuantity({ commit }, id) {
    commit("downTotal", id);
    commit("quantityMinus", id);
  },
  clearCart({ commit }) {
    commit("clearCart");
    CartData.removeCartTotal();
    CartData.removeCartItems();
    CartData.removeCartAmount();
    CartData.removeDeliveryCharge();
  },
  updateLocationId({ commit }, loc) {
    commit("updateLocationId", loc);
    LocationId.setLocationId(loc);
  },
  addDeliveryLocation({ commit }, deliLocation) {
    commit("updateDeliveryLocation", deliLocation);
  },

  // Add Promo Discount
  addDiscount({ commit }, total) {
    commit("addPromoDiscount", total);
  },

  addCFDiscount({ commit }, discount) {
    commit("addCookedFoodDiscount", discount);
  },

  addMDiscount({ commit }, discount) {
    commit("addMartDiscount", discount);
  },

  addBDiscount({ commit }, discount) {
    commit("addBakeryDiscount", discount);
  },

  addLDiscount({ commit }, discount) {
    commit("addLiquorDiscount", discount);
  },

  addPromoCode({ commit }, code) {
    commit("addPromoCode", code);
  },

  // User Functions
  updateStep({ commit }, step) {
    commit("updateFormStep", step);
  },

  updateMode({ commit }, mode) {
    commit("updatePayMode", mode);
  },

  updatePayment({ commit }, method) {
    commit("updatePaymentMethod", method);
  },

  addUserDetail({ commit, state }, detail) {
    // console.log("DETAIL IS", detail.values, detail.sM, detail.orderFor);

    commit("updateUserDetail", detail.values);
    commit("updateSM", detail.sM);
    commit("updateOrderFor", detail.orderFor);
    commit("updateFormStep", 3);
  },

  submitOrder({ commit, state }, data) {
    // console.log("On Submit Order", state.userDetail);

    let cart_total = state.cart.reduce(
      (a, b) => a + b.after_price * b.quantity,
      0
    );

    let newCart = state.cart.map(function(item) {
      return {
        item_id: item.id,
        qty: item.quantity,
        item_name: item.name,
        unit_price: item.after_price,
      };
    });

    let discount_string = {
      "cooked-food": state.cookedFoodDiscount,
      mart: state.martDiscount,
      bakery: state.bakeryDiscount,
      liquor: state.liquorDiscount,
    };

    let lat = state.locationMarker[0];
    let lng = state.locationMarker[1];
    let addressInfo =
      `${state.userDetail.deliverylocation}` +
      ` ` +
      `https://www.google.com/maps/place/${lat}` +
      `,` +
      `${lng}`;

    OrderApi.sendOrder({
      location: addressInfo,
      receipt: "",
      number: state.userDetail.receiversnumber,
      name: state.userDetail.receiversname,
      promo_code: state.promoCode,
      grand_total:
        (state.promoDiscountTotal === 0
          ? cart_total
          : state.promoDiscountTotal) +
        state.deliveryCharge +
        state.vat +
        state.intl_transfer_charge,
      productsjson: JSON.stringify(newCart),
      food_total: cart_total,
      delivery_charge: state.deliveryCharge,
      loc_id: state.loc_id,
      order_source: "web",
      discount_percent: state.promoDiscount,
      night_charge: 0,
      order_status: 2,
      sender_name: state.userDetail.sendersname,
      sender_email: state.userDetail.sendersemail,
      sender_sm: state.sM,
      sender_sm_handle: state.userDetail.senderssmusername,
      sender_note: state.userDetail.note,
      payment_method: state.paymentMethod,
      vat: state.vat,
      intl_transfer_charge: state.intl_transfer_charge,
      discount_breakdown: JSON.stringify(discount_string),
    })
      .then((response) => {
        // console.log(response, "hello this id cart.js response")
        if (response.data.error == false) {
          commit("confirmOrder");
          commit("clearCart");
          commit("updateFormStep", 0);
          router.replace("/p/orderstatus");
        } else {
          commit("orderError", response);
        }
      })
      .catch((err) => {
        commit("orderError", err);
      });
  },

  confirmOrderChange({ commit }) {
    commit("confirmOrder");
  },

  clearOrderError({ commit }) {
    commit("removeOrderError");
  },

  setMinOrder({ commit }, min) {
    commit("setMinimumOrder", min);
  },

  // Location Functions

  markerChange({ commit }, location) {
    commit("updateMarker", location);
  },

  setPromoInfo(context, value) {
    context.commit("setPromoInfo", value);
  },

  setPromoStatus(context, value) {
    context.commit("setPromoStatus", value);
  },
};

const mutations = {
  // Cart mutations

  addDeliveryCharge: (state, charge) => {
    state.deliveryCharge = charge;
  },

  addTransferCharge: (state, charge) => {
    state.intl_transfer_charge = charge;
  },

  addVATCharge: (state, charge) => {
    state.vat = charge;
  },

  addItem: (state, item) => (
    (item.quantity = 1), (state.cart = [...state.cart, item])
  ),

  addTotal: (state, price) =>
    (state.totalPrice = Math.floor(state.totalPrice + parseInt(price))),

  upTotal: (state, id) => {
    const arr = state.cart.filter((food) => food.id === id)[0];
    state.totalPrice = Math.floor(state.totalPrice + parseInt(arr.after_price));
  },

  itemPriceDelete: (state, id) => {
    const arr = state.cart.filter((food) => food.id === id)[0];
    state.totalPrice = Math.floor(
      state.totalPrice - parseInt(arr.after_price * arr.quantity)
    );
  },

  downTotal: (state, id) => {
    const arr = state.cart.filter((food) => food.id === id)[0];
    state.totalPrice = Math.floor(state.totalPrice - parseInt(arr.after_price));
  },

  itemDelete: (state, id) => {
    const index = state.cart.findIndex((item) => item.id === id);
    state.cart.splice(index, 1);
  },

  quantityAdd: (state, id) => {
    const arr = state.cart.filter((food) => food.id === id)[0];
    arr.quantity++;

    const index = state.cart.findIndex((item) => item.id === id);
    if (index !== -1) {
      state.cart.splice(index, 1, arr);
    }
  },

  quantityMinus: (state, id) => {
    const arr = state.cart.filter((food) => food.id === id)[0];
    const index = state.cart.findIndex((item) => item.id === id);
    if (arr.quantity === 1) {
      state.cart.splice(index, 1);
    } else {
      arr.quantity--;

      if (index !== -1) {
        state.cart.splice(index, 1, arr);
      }
    }
  },

  clearCart: (state) => {
    state.cart = [];
    state.totalPrice = 0;
  },

  updateLocationId: (state, loc) => {
    state.loc_id = loc;
  },

  // User detail mutations

  updateUserDetail: (state, detail) => {
    state.userDetail = detail;
    state.ordering = false;
  },

  updateDeliveryLocation: (state, detail) => {
    state.deliveryLocation = detail;
  },

  updateSM: (state, detail) => {
    state.sM = detail;
  },

  updatePaymentMethod: (state, detail) => {
    state.paymentMethod = detail;
  },

  updateOrderFor: (state, detail) => {
    state.orderFor = detail;
  },

  updateFormStep: (state, detail) => {
    state.step = detail;
  },

  updatePayMode: (state, detail) => {
    state.payMode = detail;
  },

  // Promo Discount

  addPromoDiscount: (state, total) => {
    // state.promoDiscount = discount;
    state.promoDiscountTotal = total;
  },

  addCookedFoodDiscount: (state, discount) => {
    state.cookedFoodDiscount = discount;
  },

  addMartDiscount: (state, discount) => {
    state.martDiscount = discount;
  },

  addBakeryDiscount: (state, discount) => {
    state.bakeryDiscount = discount;
  },

  addLiquorDiscount: (state, discount) => {
    state.liquorDiscount = discount;
  },

  addPromoCode: (state, code) => {
    state.promoCode = code;
  },

  //Marker mutations

  updateMarker: (state, location) => {
    state.locationMarker = location;
  },

  // Order Confirm
  confirmOrder: (state) => {
    state.popOrderConfirm = !state.popOrderConfirm;
    state.ordering = false;
  },

  orderError: (state, e) => {
    state.orderError = e.data;
  },

  removeOrderError: (state) => {
    state.orderError = "";
  },

  setMinimumOrder: (state, min) => {
    state.minOrder = min;
  },

  setPromoInfo(state, value) {
    state.promoInfo = value;
  },

  setPromoStatus(state, value) {
    state.promoStatus = value;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
